import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    routes: [
		{
			path: '/',
			name: 'Home',
			component: () => import('../views/Home.vue')
		},
		{
			path: '/about',
			name: 'About',
			component: () => import('../views/About.vue')
        },
        {
            path: '/games',
            name: 'Games',
            component: () => import('../views/Games.vue'),
            children: [
                {
                    path: 'home',
                    name: 'Games Home',
                    component: () => import('../views/games/GamesHome.vue')
                },
                {
                    path: 'minesweeper',
                    name: 'Minesweeper',
                    component: () => import('../views/games/Minesweeper.vue')
                },
                {
                    path: 'reaction-speed',
                    name: 'Reaction Speed',
                    component: () => import('../views/games/ReactionSpeed.vue')
                },
                {
                    path: 'tic-tac-toe',
                    name: 'Tic-Tac-Toe',
                    component: () => import('../views/games/TicTacToe.vue')
                }
            ]
        },
		{
			path: '/404',
			name: '404',
			component: () => import('../views/NotFound.vue')
		},
		{ path: '*', redirect: '/404' }
    ]
})

export default router
